module.exports = __webpack_public_path__ + "static/media/call_voip.14ccc862.svg";